var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUptimeMonitorImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 2,
    clipPath: "url(#clip0_4872_39424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.8359 32.2335C47.8268 32.2068 47.8203 32.1809 47.8085 32.1553C47.768 32.0645 47.7116 31.9818 47.6418 31.9108L42.6418 26.9109C42.5709 26.8411 42.4881 26.7846 42.3969 26.7442C42.3717 26.7335 42.347 26.7266 42.3222 26.7175C42.2512 26.6934 42.1776 26.6789 42.1028 26.6744C42.0853 26.6744 42.0704 26.6644 42.0528 26.6644H35.3893V12.5001H40.3893C40.8497 12.5001 41.2228 12.127 41.2228 11.6666C41.2228 11.3988 41.0942 11.1474 40.8768 10.991L25.877 0.157642C25.5859 -0.0525474 25.193 -0.0525474 24.902 0.157642L9.90181 10.991C9.52873 11.2603 9.44443 11.781 9.71375 12.1545C9.87015 12.3715 10.1219 12.5001 10.3893 12.5001H15.3896V26.7907C14.8376 26.7102 14.2807 26.6686 13.723 26.6667C7.27959 26.6637 2.05383 31.8849 2.05078 38.3283C2.04773 44.7717 7.26891 49.997 13.7123 50.0001C16.3322 50.0012 18.8759 49.1208 20.9343 47.4999H30.3894V49.1666C30.3894 49.627 30.7625 50.0001 31.2225 50.0001H47.0558C47.5163 50.0001 47.8893 49.627 47.8893 49.1666V32.5002C47.8893 32.4819 47.8802 32.4658 47.8786 32.4475C47.8745 32.3747 47.86 32.3026 47.8359 32.2335ZM45.0443 31.6667H42.8894V29.5117L45.0443 31.6667ZM13.7226 28.3334C17.7956 28.3189 21.4661 30.787 22.9893 34.5643L14.1335 37.3334L9.76868 29.1509C11.0176 28.613 12.3631 28.3349 13.7226 28.3334ZM23.4844 36.1558C23.6431 36.8711 23.7228 37.6012 23.7228 38.3336C23.724 39.6047 23.4791 40.8639 23.0019 42.0419L15.9443 38.5125L17.0753 38.1585L23.4844 36.1558ZM3.72276 38.3332C3.72086 34.9378 5.44472 31.7739 8.29849 29.9344L12.9875 38.7258L12.9936 38.7341C13.007 38.7586 13.026 38.7776 13.0409 38.8001C13.0684 38.8429 13.0993 38.8833 13.1332 38.9211L13.1443 38.9325C13.163 38.9478 13.1825 38.9623 13.2027 38.9752C13.2412 39.0069 13.2828 39.0344 13.3266 39.0584C13.335 39.0626 13.3408 39.0702 13.3499 39.0752L22.2549 43.5277C19.3878 48.2438 13.2404 49.7426 8.52471 46.8755C5.54199 45.0624 3.72162 41.8241 3.72276 38.3332ZM30.3894 27.5002V45.8333H22.6452C23.2319 45.1325 23.7354 44.3662 24.1451 43.5491C24.9634 41.9324 25.3895 40.1456 25.3895 38.3332C25.3944 33.1727 22.0032 28.6237 17.0559 27.155V11.6666C17.0559 11.2065 16.6828 10.8335 16.2228 10.8335H12.9669L25.3895 1.8609L37.8117 10.8335H34.5562C34.0958 10.8335 33.7227 11.2065 33.7227 11.6666V26.6667H31.2225C30.7625 26.6667 30.3894 27.0398 30.3894 27.5002ZM32.056 48.3335V28.3334H41.2228V32.5002C41.2228 32.9602 41.5958 33.3333 42.0559 33.3333H46.2227V48.3335H32.056Z",
    fill: "url(#paint0_linear_4872_39424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.7227 29.9998H39.5561V31.6664H33.7227V29.9998Z",
    fill: "url(#paint1_linear_4872_39424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.7227 33.333H39.5561V34.9996H33.7227V33.333Z",
    fill: "url(#paint2_linear_4872_39424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.052 34.2345C43.6293 34.0529 43.1392 34.249 42.958 34.672L40.7912 39.7292L37.3446 38.1968C36.9304 38.0129 36.4447 38.1941 36.2521 38.6042L33.8073 43.8128C33.6116 44.2294 33.7909 44.7253 34.2071 44.921C34.3165 44.9728 34.4363 44.9999 34.5572 45.0003C34.8803 44.9999 35.1741 44.8134 35.3114 44.5208L37.4122 40.0519L40.8854 41.5953C41.3062 41.7819 41.7987 41.5923 41.9852 41.1719C41.9867 41.1684 41.9883 41.165 41.9898 41.162L44.4896 35.3285C44.6707 34.9055 44.4751 34.4157 44.052 34.2345Z",
    fill: "url(#paint3_linear_4872_39424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.5562 45.0002H44.5561V46.6669H39.5562V45.0002Z",
    fill: "url(#paint4_linear_4872_39424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.05615 14.1667H7.88959V15.8334H2.05615V14.1667Z",
    fill: "url(#paint5_linear_4872_39424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.05615 17.4998H7.88959V19.1664H2.05615V17.4998Z",
    fill: "url(#paint6_linear_4872_39424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.05615 20.833H7.88959V22.4996H2.05615V20.833Z",
    fill: "url(#paint7_linear_4872_39424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M42.0557 2.5H47.8891V4.16664H42.0557V2.5Z",
    fill: "url(#paint8_linear_4872_39424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M42.0557 5.83325H47.8891V7.49989H42.0557V5.83325Z",
    fill: "url(#paint9_linear_4872_39424)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4872_39424",
    x1: 24.9701,
    y1: 0,
    x2: 24.9701,
    y2: 50.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938146,
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4872_39424",
    x1: 36.6394,
    y1: 29.9998,
    x2: 36.6394,
    y2: 31.6664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938146,
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4872_39424",
    x1: 36.6394,
    y1: 33.333,
    x2: 36.6394,
    y2: 34.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938146,
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4872_39424",
    x1: 39.1426,
    y1: 34.1667,
    x2: 39.1426,
    y2: 45.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938146,
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4872_39424",
    x1: 42.0561,
    y1: 45.0002,
    x2: 42.0561,
    y2: 46.6669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938146,
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4872_39424",
    x1: 4.97287,
    y1: 14.1667,
    x2: 4.97287,
    y2: 15.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938146,
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4872_39424",
    x1: 4.97287,
    y1: 17.4998,
    x2: 4.97287,
    y2: 19.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938146,
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4872_39424",
    x1: 4.97287,
    y1: 20.833,
    x2: 4.97287,
    y2: 22.4996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938146,
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4872_39424",
    x1: 44.9724,
    y1: 2.5,
    x2: 44.9724,
    y2: 4.16664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938146,
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4872_39424",
    x1: 44.9724,
    y1: 5.83325,
    x2: 44.9724,
    y2: 7.49989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938146,
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#418DE8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4872_39424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptimeMonitorImage);
export default __webpack_public_path__ + "static/media/uptimeMonitorImage.b471faeb7e15c3f6d68482295b496d6a.svg";
export { ForwardRef as ReactComponent };